import { extractDate } from 'dmpconnectjsapp-base/helpers/accessors';
import { isReady }     from 'dmpconnectjsapp-base/helpers/common';
import { insTypes }    from '../../constants/dmpConstants';

export const vitaleCardStatuses = {
  MISSING_CARD: 1,
  REAL_CARD: 3,
  TEST_CARD: 4,
  DEMO_CARD: 5,
};

export const insTypeByVitaleCardStatus = {
  [vitaleCardStatuses.DEMO_CARD]: [insTypes.DEMO_INS],
  [vitaleCardStatuses.REAL_CARD]: [insTypes.REAL_INS],
  [vitaleCardStatuses.TEST_CARD]: [insTypes.TEST_INS],
};

export const getQualifiedIns = (nir, vitaleCardStatus) => (nir ? `${nir.replace(/ /g, '')}${insTypeByVitaleCardStatus[vitaleCardStatus]}` : undefined);

export const getSelectedVitaleCardPatientFromCertifiedIns = (certifiedIdentitySection, vitaleCardSection, ins) => {
  if (!vitaleCardSection || !isReady(vitaleCardSection)) return false;

  const selectedPatientIndex = Object.entries(certifiedIdentitySection).filter((patient) => {
    const values = patient[1];
    const { Ins } = values;
    if (!Ins) return false;
    const { s_ins, s_insType } = Ins;
    const qualifiedIns = s_ins + s_insType;
    return ins === qualifiedIns;
  }).map(value => value[0].split('_')[1]);

  if (selectedPatientIndex.length === 0) return false;
  const { Patients } = vitaleCardSection;
  return Patients[Number(selectedPatientIndex[0])];
};

export const getVitaleCardDataFromIndex = (vitaleCardSection, vitaleIndex) => {
  if (isReady(vitaleCardSection)) {
    const { Patients } = vitaleCardSection;
    return Patients[vitaleIndex];
  }
  return null;
};

export const patientDataToRawVitaleData = (patientData, rightsHolder) => {
  const
    {
      HealthCoverage,
      s_name: nomUsuel,
      s_birthname: nomPatronymique,
      s_given: prenomUsuel,
      s_birthdayYYYYMMDD,
      i_quality: qualBenef,
      i_birthRank: rangDeNaissance,
      s_certifiedNir: nirCertifie,
      s_nir: nir,
    } = patientData;
  
  const
    {
      // s_certifiedNir: rhNirCertifie,
      s_nir: rhNir,
    } = rightsHolder;
  
  const splittedNir         = nir.split(' ');
  const splittedNirCertifie = nirCertifie.split(' ');
  const rhSplittedNir         = rhNir.split(' ');
  // const rhSplittedNirCertifie = rhNirCertifie.split(' ');

  return {
    RightsHolderNir: {
        s_nir : rhSplittedNir[0],
        s_key : rhSplittedNir[1],
      },
    BeneficiaryVitaleData: {
      s_name        : nomUsuel,
      s_birthName   : nomPatronymique,
      s_givenName   : prenomUsuel,
      s_birthday    : extractDate(s_birthdayYYYYMMDD, 'YYYYMMDD').format('DDMMYYYY'),
      i_rank        : Number(rangDeNaissance),
      i_qualBenef   : Number(qualBenef),
      NirData       : {
        Nir                : {
          s_nir: splittedNir[0],
          s_key: splittedNir[1],
        },
        CertifiedNir       : {
          s_nir: splittedNirCertifie && splittedNirCertifie.length === 2 ? splittedNirCertifie[0] : '',
          s_key: splittedNirCertifie && splittedNirCertifie.length === 2 ? splittedNirCertifie[1] : '',
        },
        s_certificationDate: "",
      },
      HealthCoverage,
    },
  }
}
